// PointsOfInterest

import List from '../../pages/Places/PointsOfInterest/List';
import Create from '../../pages/Places/PointsOfInterest/Create';
import Detail from '../../pages/Places/PointsOfInterest/Detail';

export const subRoutesPointsOfInterest = [
    {
        path: "",
        component: List,
        exact: true,
    }
].map((item) => {
    return {
        ...item,
        path: `/pointsOfInterest${item.path}`,
        private: true
    };
});

export const routesPointsOfInterest = [
    {
        path: "/create",
        component: Create,
        exact: true,
    },
    {
        path: "/:elementId",
        component: Detail,
    },
].map((item) => {
    return {
        ...item,
        path: `/pointsOfInterest${item.path}`,
        private: true
    };
});